import Loader from '@/components/Loader';
import { useConfirmation } from '@/hooks/useConfirmation';
import {
  TService,
  useDeleteService,
  useSaveService,
  useService,
} from '@/models/services';
import { Center, Space, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useLocation, useParams } from 'wouter';
import ServiceEditor from './ServiceEditor';

export default function ServiceEditPage() {
  const { id } = useParams();
  const { data: service, isError, isLoading } = useService(parseInt(id!));
  const { mutate: saveService } = useSaveService();
  const { mutate: deleteService } = useDeleteService();
  const [_, nav] = useLocation();

  const { confirm, ConfirmationDialog } = useConfirmation();

  if (isLoading) {
    return <Loader />;
  }

  if (!service || isError) {
    return (
      <Center>
        <Text m={'xl'}>
          Service not found or you have no access to view it.
        </Text>
      </Center>
    );
  }

  return (
    <>
      <ServiceEditor
        title={service.name}
        service={service}
        onSave={(updatedService) => {
          saveService(updatedService as TService, {
            onSuccess: () => {
              notifications.show({
                title: 'Service successfully saved',
                message: `Service "${updatedService.name}" was saved successfully.`,
                color: 'green',
                position: 'top-right',
              });
            },
          });
        }}
        onDelete={async () => {
          const confirmed = await confirm({
            title: 'Delete Service',
            message: `Are you sure you want to delete service "${service.name}"?`,
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
          });

          if (confirmed) {
            deleteService(service.id, {
              onSuccess: () => {
                notifications.show({
                  title: 'Done',
                  message: `Service "${service.name}" was deleted successfully.`,
                  color: 'green',
                  position: 'top-right',
                });
                nav('../');
              },
            });
          }
        }}
      />
      <Space h={'xl'} />
      <ConfirmationDialog />
    </>
  );
}
